import { useSelector } from "react-redux";
import { RootState } from "store";
import { getLocalStorage } from "Network/ApiService";

// const VOYAGE_CONTROL_EMAIL_DOMAIN = "voyagecontrol.com"; // BUGS-535: see isVoyageControlGlobalAdmin below

export const usePermissions = () => {
  const { userData } = useSelector((state: RootState) => state.auth);
  
  const isGlobalAdmin = userData?.isGlobalAdminUser || false;
  const isAdmin = userData?.isAdmin || false;
  const isOrgAdmin = userData?.role === "organization_admin" || userData?.isOrganizationAdmin || false;

  
  const isVoyageControlGlobalAdmin = isGlobalAdmin;

  return {
    isGlobalAdmin,
    isAdmin,
    isOrgAdmin,
    isVoyageControlGlobalAdmin,
    userRole: userData?.role,
    menuAccess: userData?.menuAccess || [],
    hasAccess: (requiredRole: "global" | "org" | "admin") => {
      if (requiredRole === "global") return isGlobalAdmin;
      if (requiredRole === "admin") return isGlobalAdmin || isAdmin;
      return isGlobalAdmin || isOrgAdmin || isAdmin;
    },
  };
};